import Vue from 'vue'
import api from '@/utils/api.js'
import position from '@/utils/position'
// import axios from 'axios'
// import qs from 'qs'
var redirectLogin = '0'
/**
 * Get请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 * @return [null] 无
 */
Vue.prototype.get = function (param, callback) {
  let query = param.data ? param.data : {}
  query['BDSOFT-TOKEN']=sessionStorage.getItem('BDSOFT-TOKEN')
  console.log(api[param.url])
  // query['BDSOFT-TOKEN'] = this.g('dongaoToken')
  Vue.http.get(api[param.url], {params: query}, {
    headers: {
      'BDSOFT-TOKEN': sessionStorage.getItem('BDSOFT-TOKEN')
      
    },
    emulateJSON: true
  }).then(res => {
    if(res.body.code == 401){
      this.$message.error('登录时间超时，请重新登录')
    }
    // if (!position.huanjing) {
    //   if (res.body.code === 3021) {
    //     window.location.href = res.body.data
    //     return
    //   }
    // }
    // if (res.body.code !== 200) {
    //   if (res.body.code === 401 || res.body.code === 501) {
    //     if (redirectLogin !== '1') {
    //       redirectLogin = '1'
    //       setTimeout(() => { redirectLogin = '0' }, 3000)
    //       this.$confirm('你已经登出或登录已超时，你可以取消保持当前页面，或者重新登录。', '登出提醒', {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         this.$store.commit('setDeptTree', {key: '0', value: []})
    //         this.$store.commit('setDeptTree', {key: '1', value: []})
    //         this.$store.commit('setFunctionVOTree', [])
    //         this.clear()
    //         if (position.huanjing) {
    //           this.$router.push('/login')
    //         }
    //       }).catch(() => {})
    //     }
    //   } else if (res.body.code === 403) {
    //     let info = {
    //       code: res.body.code,
    //       message: '您无权限访问该功能'
    //     }
    //     callback(info)
    //   } else if (res.body.code === 500) {
    //     callback(res.body)
    //   } else {
    //     let info = {
    //       code: res.body.code,
    //       message: res.body.message || '未知错误！'
    //     }
    //     callback(info)
    //   }
    // } else {
    //   callback(res.body)
    // }
    callback(res.body)
  }, res => {
    console.log(res)
    this.$message.error('网络异常，稍后再试')
    let info = {
      code: 500
    }
    callback(info)
  })
}

/**
 * Post请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 * @return [null] 无
 */
Vue.prototype.post = function (param, callback) {
  let query = param.data ? param.data : {}
  Vue.http.post(api[param.url], query, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'BDSOFT-TOKEN': sessionStorage.getItem('BDSOFT-TOKEN'),
      'Accept': 'application/json, text/plain, */*'
    },
    emulateJSON: true
  }).then(res => {
    // if (!position.huanjing) {
    //   if (res.body.code === 3021) {
    //     window.location.href = res.body.data
    //     return
    //   }
    // }
    // if (res.body.code !== 200) {
    //   if (res.body.code === 401 || res.body.code === 501) {
    //     if (redirectLogin !== '1') {
    //       redirectLogin = '1'
    //       setTimeout(() => { redirectLogin = '0' }, 3000)
    //       this.$confirm('你已经登出或登录已超时，你可以取消保持当前页面，或者重新登录。', '登出提醒', {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         this.$store.commit('setDeptTree', {key: '0', value: []})
    //         this.$store.commit('setDeptTree', {key: '1', value: []})
    //         this.$store.commit('setFunctionVOTree', [])
    //         this.clear()
    //         if (position.huanjing) {
    //           this.$router.push('/login')
    //         }
    //       }).catch(() => {})
    //     }
    //   } else if (res.body.code === 403) {
    //     let info = {
    //       code: res.body.code,
    //       message: '您无权限访问该功能'
    //     }
    //     callback(info)
    //   } else if (res.body.code === 500) {
    //     callback(res.body)
    //   } else {
    //     let info = {
    //       code: res.body.code,
    //       message: res.body.message || '未知错误！'
    //     }
    //     callback(info)
    //   }
    // } else {
    //   callback(res.body)
    // }
    callback(res.body)
  }, res => {
    this.$message.error('网络异常，稍后再试')
    let info = {
      code: 500
    }
    callback(info)
  })
}

/**
 * Put请求
 * @param [object] [请求参数]
 * @callback [function] [回调函数]
 * @return [null] 无
 */
// Vue.prototype.put = function (param, callback) {
//   let query = param.data ? param.data : {}
//   Vue.http.put(api[param.url], query, {
//     headers: {
//       'BDSOFT-TOKEN': this.g('dongaoToken')
//     },
//     emulateJSON: true
//   }).then(res => {
//     if (res.body.code !== 200) {
//       if (res.body.code === 401 || res.body.code === 501) {
//         if (redirectLogin !== '1') {
//           redirectLogin = '1'
//           setTimeout(() => { redirectLogin = '0' }, 3000)
//           this.$confirm('你已经登出或登录已超时，你可以取消保持当前页面，或者重新登录。', '登出提醒', {
//             confirmButtonText: '重新登录',
//             cancelButtonText: '取消',
//             type: 'warning'
//           }).then(() => {
//             this.$store.commit('setDeptTree', {key: '0', value: []})
//             this.$store.commit('setDeptTree', {key: '1', value: []})
//             this.$store.commit('setFunctionVOTree', [])
//             this.clear()
//             if (position.huanjing) {
//               this.$router.push('/login')
//             }
//           }).catch(() => {})
//         }
//       } else if (res.body.code === 403) {
//         let info = {
//           code: res.body.code,
//           message: '您无权限访问该功能'
//         }
//         callback(info)
//       } else if (res.body.code === 500) {
//         callback(res.body)
//       } else {
//         let info = {
//           code: res.body.code,
//           message: res.body.message || '未知错误！'
//         }
//         callback(info)
//       }
//     } else {
//       callback(res.body)
//     }
//   }, res => {
//     this.$message.error('网络异常，稍后再试')
//     let info = {
//       code: 500
//     }
//     callback(info)
//   })
// }


Vue.prototype.delete = function (param, callback) {
  let query = param.data ? param.data : {}
  query['BDSOFT-TOKEN']=sessionStorage.getItem('BDSOFT-TOKEN')
  console.log(api[param.url])
  // query['BDSOFT-TOKEN'] = this.g('dongaoToken')
  Vue.http.delete(api[param.url], {params: query}, {
    headers: {
      
    },
    emulateJSON: true
  }).then(res => {
    if(res.body.code == 401){
      this.$message.error('登录时间超时，请重新登录')
    }
    // if (!position.huanjing) {
    //   if (res.body.code === 3021) {
    //     window.location.href = res.body.data
    //     return
    //   }
    // }
    // if (res.body.code !== 200) {
    //   if (res.body.code === 401 || res.body.code === 501) {
    //     if (redirectLogin !== '1') {
    //       redirectLogin = '1'
    //       setTimeout(() => { redirectLogin = '0' }, 3000)
    //       this.$confirm('你已经登出或登录已超时，你可以取消保持当前页面，或者重新登录。', '登出提醒', {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }).then(() => {
    //         this.$store.commit('setDeptTree', {key: '0', value: []})
    //         this.$store.commit('setDeptTree', {key: '1', value: []})
    //         this.$store.commit('setFunctionVOTree', [])
    //         this.clear()
    //         if (position.huanjing) {
    //           this.$router.push('/login')
    //         }
    //       }).catch(() => {})
    //     }
    //   } else if (res.body.code === 403) {
    //     let info = {
    //       code: res.body.code,
    //       message: '您无权限访问该功能'
    //     }
    //     callback(info)
    //   } else if (res.body.code === 500) {
    //     callback(res.body)
    //   } else {
    //     let info = {
    //       code: res.body.code,
    //       message: res.body.message || '未知错误！'
    //     }
    //     callback(info)
    //   }
    // } else {
    //   callback(res.body)
    // }
    callback(res.body)
  }, res => {
    console.log(res)
    this.$message.error('网络异常，稍后再试')
    let info = {
      code: 500
    }
    callback(info)
  })
}


// WEBPACK FOOTER //
// ./src/utils/http.js